function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMediaRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 4a2 2 0 012 2v20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h24zM4 26h24V6H4v20zm6-2H7v-2h3v2zm5 0h-3v-2h3v2zm5 0h-3v-2h3v2zm5 0h-3v-2h3v2zm-5-8l-7 4v-8l7 4zm-10-6H7V8h3v2zm5 0h-3V8h3v2zm5 0h-3V8h3v2zm5 0h-3V8h3v2z",
    fill: props.color
  }));
}

export default SvgIconMediaRexOutline;